function copyStyles(style, element) {
  /* eslint-disable no-param-reassign */
  element.style.fontSize = style.fontSize;
  element.style.fontFamily = style.fontFamily;
  element.style.fontWeight = style.fontWeight;
  element.style.fontStyle = style.fontStyle;
  element.style.letterSpacing = style.letterSpacing;
  element.style.textTransform = style.textTransform;
  /* eslint-enable no-param-reassign */
}

export default function copyInputStyles(inputRef, sizerRef) {
  if (inputRef.current == null || sizerRef.current == null) return;
  var inputStyle = window.getComputedStyle(inputRef.current);
  copyStyles(inputStyle, sizerRef.current);
}